import { ProfilePageBannerData } from '@/modules/client-setting/type'
import { ColumnDef } from '@tanstack/react-table'
import UpdateProfilePageBanner from './CellAction/UpdateProfilePageBanner'
import DeleteProfilePageBanner from './CellAction/DeleteProfilePageBanner'
import { IsActiveProfilePageBanner } from './CellAction/IsActiveProfilePageBanner'

export const columns: ColumnDef<ProfilePageBannerData>[] = [
	{
		accessorKey: 'order',
		header: 'ลำดับ',
		cell: ({ row }) => <span>{row.original.order}</span>,
	},
	{
		accessorKey: 'title',
		header: 'ชื่อปุ่ม',
	},
	{
		accessorKey: 'image',
		header: 'ไอคอน',
		cell: ({ row }) => (
			<div className="flex items-center">
				<img
					src={row.original.image}
					alt={row.original.title}
					className="h-8 w-8 object-contain"
				/>
			</div>
		),
	},
	{
		accessorKey: 'type',
		header: 'ประเภท',
		cell: ({ row }) => (
			<span className="capitalize">
				{row.original.type === 'GAME' ? 'เกม' : 'ลิงก์'}
			</span>
		),
	},
	{
		accessorKey: 'link',
		header: 'ลิงก์/เกม',
		cell: ({ row }) => {
			const { type, link, gameCode } = row.original
			if (type === 'GAME' && gameCode) {
				return <span className="text-blue-600">เกม: {gameCode}</span>
			}
			if (type === 'LINK' && link) {
				return (
					<span className="max-w-xs truncate text-green-600" title={link}>
						{link}
					</span>
				)
			}
			return <span className="text-gray-400">-</span>
		},
	},
	{
		accessorKey: 'isActive',
		header: 'โชว์ปุ่มบนหน้าฉัน',
		cell: ({ row }) => <IsActiveProfilePageBanner row={row.original} />,
	},
	{
		id: 'actions',
		header: 'จัดการ',
		cell: ({ row }) => (
			<div className="flex items-center gap-2">
				<UpdateProfilePageBanner data={row.original} />
				<DeleteProfilePageBanner data={row.original} />
			</div>
		),
	},
]

export const writeAccessorKeys = ['actions', 'isActive']
